import { pageModule } from '@components/pageModule';
import { Route } from '@packages/router';
import { AsyncPageRender } from '../../../Components/AsyncComponent';
import { ProtectedRoute } from '../../../Components/Layout/ProtectedRoute';

export const routes$ = {
    List: AsyncPageRender(() => pageModule(import('./List'))),
    View: AsyncPageRender(() => pageModule(import('./View'))),
    SalesLedgerListing: AsyncPageRender(() => pageModule(import('./SalesLedger/List'))),
    PayoutListing: AsyncPageRender(() => pageModule(import('./Payouts/List'))),
    PayoutView: AsyncPageRender(() => pageModule(import('./Payouts/View'))),
    Users: AsyncPageRender(() => pageModule(import('./Users'))),
    OrdersListing: AsyncPageRender(() => pageModule(import('./Orders'))),
};

function Router() {
    return (
        <>
            <Route
                name={'Wholesalers.List'}
                exact
                path={'/wholesalers/list/:tab'}
                component={ProtectedRoute(routes$.List)}
            />

            <Route
                name={'Wholesaler.View'}
                exact
                path={'/wholesaler/:id/view/:tab'}
                component={ProtectedRoute(routes$.View)}
            />

            <Route
                name={'Wholesalers.SalesLedger'}
                exact
                path={'/wholesalers/sales-ledger'}
                component={ProtectedRoute(routes$.SalesLedgerListing)}
            />

            <Route
                name={'Wholesalers.Payout'}
                exact
                path={'/wholesalers/payouts'}
                component={ProtectedRoute(routes$.PayoutListing)}
            />

            <Route
                name={'Wholesalers.PayoutDetails'}
                exact
                path={'/wholesalers/payout/:id'}
                component={ProtectedRoute(routes$.PayoutView)}
            />

            <Route
                name={'Wholesaler.Users'}
                exact
                path={'/wholesaler/users'}
                component={ProtectedRoute(routes$.Users)}
            />

            <Route
                name={'Wholesalers.Orders.List'}
                exact
                path={'/wholesalers/:type/:tab?'}
                component={ProtectedRoute(routes$.OrdersListing)}
            />
        </>
    );
}

export default Router;
